// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
export default {
	page_title: "Boeking",
	navbar_tab_1: "Avion",
	navbar_tab_2: "Extra’s",
	navbar_tab_3: "Contactgegevens",
	navbar_tab_4: "Betaling",
	step: "STAP",
	you_accommodation: "Accommodatie",
	adult: "volwassene",
	Adult: "Volwassene",
	adults: "volwassenen",
	Adults: "Volwassenen",
	child: "kind",
	Child: "Kind",
	children: "kinderen",
	Children: "Kinderen",
	age: "leeftijd",
	ages: "leeftijden",
	mister: "Dhr.",
	madam: "Mevr.",
	see_more: "Zie meer",
	see_less: "Sluit",
	yes: "Ja",
	no: "Nee",
	see_more_options: "Bekijk meer opties",
	more_infos: "Meer info",
	images_copyright: "Foto’s zijn ter illustratie en kunnen verschillen van de werkelijkheid",
	day_monday: "Maandag",
	day_tuesday: "Dinsdag",
	day_wednesday: "Woensdag",
	day_thursday: "Donderdag",
	day_friday: "Vrijdag",
	day_saturday: "Zaterdag",
	day_sunday: "Zondag",
	month_january: "Januari",
	month_february: "Februari",
	month_march: "Maart",
	month_april: "April",
	month_may: "Mei",
	month_june: "Juni",
	month_july: "Juli",
	month_august: "Augustus",
	month_september: "September",
	month_october: "Oktober",
	month_november: "November",
	month_december: "December",
	options_modify: "Aanpassen",
	options_modify_panel: "Wijzig",
	options_panel_title_modify: "Wijzig",
	options_panel_title_modify_la: "Wijzig",
	options_panel_title_modify_for_1: "Wijzig",
	options_panel_title_modify_for_2: "van",
	options_add: "Toevoegen",
	options_included: "Inbegrepen",
	options_day: "dag",
	options_days: "dagen",
	options_days_2: "dagen",
	options_from: "van",
	options_to: "tot",
	options_validate_selection: "Mijn keuze bevestigen",
	validate_for_all_participants: "Bevestig mijn selectie voor alle deelnemers",
	options_removed: "is verwijderd uit pakket",
	options_error_sorry: "Helaas,",
	options_error_default_service: "deze service",
	options_error_not_available: "is niet langer beschikbaar.",
	options_no_service_selected: "Geen dienst geselecteerd",
	options_no_skipass: "Geen skipas geselecteerd",
	options_no_equipment: "Geen ski-/snowboard materiaal geselecteerd",
	options_no_transport: "Geen vervoer geselecteerd",
	options_no_esf: "Geen ski-/snowboardlessen geselecteerd",
	options_no_insurance_skier: "Geen verzekering geselecteerd",
	options_no_hotel_service: "Geen extra diensten geselecteerd",
	options_15_cancellation: "Gratis annuleren tot 15 dgn voor aankomst m.u.v. boekingen Pierre & Vacances + Events dan ANVR voorwaarden",
	options_45_cancellation: "Gratis 100% annuleren tot 40 dgn voor aankomst, m.u.v. Events dan ANVR voorwaarden*",
	options_45_cancellation_under_sentence: "*Voor meer informatie, raadpleeg onze Algemene Voorwaarden",
	options_who_departs: "Reizigers",
	options_please_fill_participants: "Vul de namen en leeftijden (op aankomstdatum) van alle deelnemers in.",
	options_fill_names: "Vul de namen en leeftijden van alle deelnemers en profiteer van de beste prijzen.",
	options_participant: "Reiziger",
	options_years: "jaar",
	options_years_and_more: "en ouder",
	options_age_at_start: "Leeftijd bij aanvang van de reis",
	options_first_name: "Voornaam",
	options_lastname: "Achternaam",
	options_travelers_error_message: "Vul de voor- en achternaam en de leeftijd van elke reiziger in",
	options_prepare_your_voyage: "Pas je reis aan",
	options_select_your_insurances: "Selecteer verzekering",
	options_change_traveler_age: "Het wijzigen van de leeftijd van de reiziger zal al zijn/haar opties resetten.",
	options_change_traveler_age_confirmation: "De leeftijd van de volgende reiziger(s) is bijgewerkt. Al hun opties zijn gereset.",
	options_change_traveler_age_updated: "Deelnemersinformatie is bijgewerkt",
	options_I_understood: "Begrepen",
	options_skipass: "Skipas",
	options_no_skipass_selected: "Geen skipas geselecteerd",
	options_km_ski_slopes: "km pistes",
	options_of_tracks: "pistes",
	options_remove_skipass_1: "Als je deze optie uit je pakket haalt, blijft er een bedrag van",
	options_remove_skipass_2: "over",
	options_no_queues: "Bij het inchecken ontvang je naast je sleutels ook direct je geboekte skipassen",
	options_skipass_blue_sentence: "Bespaar tijd en geld",
	options_equipment: "Skimateriaal",
	options_select_level: "Kies categorie",
	criteria_997: "Eco",
	criteria_998: "Zilver",
	criteria_999: "Goud",
	criteria_1000: "Platinum",
	criteria_1031: "Espoir",
	criteria_1030: "Champion",
	options_no_equipment_selected: "Geen ski-/snowboard materiaal geselecteerd",
	options_enjoy_skiing_at_arrival_1: "Haal je uitrusting op bij de skishop",
	options_enjoy_skiing_at_arrival_2: "gelegen op",
	options_enjoy_skiing_at_arrival_3: "meter van je accommodatie",
	options_helmet: "Skihelm",
	options_shoes: "Skischoenen",
	options_sticks: "Skistokken",
	options_equipment_blue_sentence: "Dichtbij en eenvoudig",
	options_transport: "Vervoer",
	options_enjoy_skiing_at_arrival: "Profiteer van skiën/snowboarden direct bij aankomst!",
	options_distance_from_ski_shop_1: "De skishop",
	options_distance_from_ski_shop_2: "bevindt zich op",
	options_distance_from_ski_shop_3: "van je accommodatie",
	options_distance_from_ski_shop_4: "bevindt zich in hetzelfde gebouw als uw accommodatie!,",
	options_add_transport: "Vervoer toevoegen",
	options_add_transport_for: "Voeg vervoer toe voor",
	options_delete_transport: "Vervoer verwijderen",
	options_transport_first_date: "Ga naar",
	options_transport_second_date: "Terug",
	options_package_travelski: "Travelski Pakket:",
	options_train_plus_shuttle: "trein + shuttle.",
	options_no_transport_selected: "Geen vervoer geselecteerd",
	options_choose_a_go: "Kies heenreis",
	options_choose_a_return: "Kies terugreis",
	options_departure_station: "Opstapplaats bij heenreis",
	options_arrival_station: "Uitstapplaats bij heenreis",
	options_one_way_option: "Opties",
	options_i_travel_in: "Ik reis met:",
	options_my_transfer: "Mijn transfe",
	options_transport_summary_for: "Overzicht van vervoer voor",
	options_total_transport: "Totaal vervoer",
	options_information: "Informatie",
	criteria_1039: "1e klas",
	criteria_1040: "2e klas",
	shuttle: "Shuttle",
	taxi: "Taxi",
	baggage_cabin: "Handbagage",
	backpack: "Rugzak",
	wifi: "Wifi",
	meal: "Maaltijd",
	dinner: "Diner",
	options_how_to_choose_title: "Hoe kies ik een skiles die past bij mijn niveau?",
	options_ski_lesson: "Skilessen",
	options_take_esf: "Selecteer ski-/snowboardlessen",
	options_course_on: "Ski-/snowboardlessen op",
	options_how_i_choose_lesson: "Kies een les die past bij jouw skiniveau",
	options_beginner: "Beginner",
	options_piou_piou: "Piou-Piou",
	criteria_992: "Ourson",
	criteria_993: "Flocon",
	criteria_994: "1e ster",
	criteria_995: "2e ster",
	criteria_996: "3e ster",
	criteria_1058: "Niv. 0",
	criteria_1059: "Niv. 1",
	criteria_1060: "Niv. 2",
	criteria_1061: "Niv. 3",
	criteria_1062: "Niv. 4",
	criteria_1063: "Niv. 5",
	options_no_course_selected: "Geen ski-/snowboardlessen geselecteerd",
	options_content_piou_piou: "Ik wil spelen in de sneeuw en voor de eerste keer glijden op ski’s.",
	options_content_ourson_title: "Ik ga voor het eerst skiën",
	options_content_ourson: "Ik wil leren hoe ik mijn evenwicht bewaar, bochten maak met de pizzapunt, snelheid controleer en in de stoeltjeslift of sleeplift stap.",
	options_content_flocon_title: "Ik heb mijn Ourson behaald",
	options_content_flocon: "Ik maak snelle en lange bochten",
	options_content_1_star_title: "Ik heb mijn Flocon behaald",
	options_content_1_star: "Ik maak een pizzapunt en neem zelf een sleeplift",
	options_content_2_star_title: "Ik heb mijn eerste ster. Ik ski overal op blauwe pistes.",
	options_content_2_star: "Ik maak mijn bochten parallel",
	options_content_3_star_title: "Ik heb mijn 2e ster behaald",
	options_content_3_star: "Ik moet mijn parallelle bochten perfectioneren om controle te behouden als ik snel ga",
	options_content_adulte_beginner_title: "Ik ga voor het eerst skiën",
	options_content_adulte_beginner: "Ik wil leren hoe ik mijn evenwicht bewaar, bochten maak met de pizzapunt, snelheid controleer en in de stoeltjeslift of sleeplift stap.",
	options_adults_beginner: "Volwassenen - beginnend skiër",
	options_watch_video: "Bekijk de video",
	options_back_to_choices: "Terug naar de keuzes van de reizigers",
	options_age_group_1: "3 tot 4 jaar",
	options_age_group_2: "4 tot 5 jaar",
	options_age_group_3: "6 tot 12 jaar",
	options_age_group_4: "13 jaar en ouder (Volwassenen)",
	options_restaurant: "Restaurant",
	options_catering_services: "Catering naar jouw smaak",
	options_facilitate_arrival: "Faciliteer je aankomst door je diensten te reserveren",
	options_reserve_your_services: "Reserveer je diensten",
	options_take_accommodation_services: "Selecteer extra diensten",
	options_book_services: "Boek extra diensten",
	options_book_services_easy: "Reserveer extra diensten om jouw aankomst te vergemakkelijken",
	options_insurance: "Verzekering",
	options_take_insurance: "Kies reisverzekering",
	options_no_insurance_selected: "Geen verzekering geselecteerd",
	options_insurance_advantages: "De voordelen van een reisverzekering",
	options_per_pers: "pers",
	options_breakage_theft: "Schade en diefstal van persoonlijke of gehuurde ski-uitrusting",
	options_rescue_research: "Kosten voor zoek- en reddingsacties op de pistes",
	options_hospitalization: "Kosten voor medische behandeling en ziekenhuisverblijf",
	options_repatriation: "Repatriëringskosten",
	options_interruption_stay: "Kosten voor onderbreking van het verblijf en terugbetalingen voor ongebruikte diensten",
	options_snow_guarantee: "Sneeuwgarantie",
	options_insurance_annulation: "Annuleringsverzekering",
	options_per_booking: "Boeking",
	options_cancellation: "Annulering mogelijk tot de dag voor aankomst",
	options_reimbursement: "Terugbetaling per bankoverschrijving voor ongeldige redenen",
	options_credit_note: "Dekt gevallen die niet door creditcards worden gedekt",
	options_coverage_price: "Voucher 12 maanden geldig voor ongeldige redenen",
	options_insurance_annulation_no: "Ik hoef geen verzekering",
	options_insurance_annulation_yes: "Neem verzekering",
	options_insurance_slogan: "Gedekt zijn tijdens het verblijf",
	options_person: "persoon",
	options_free: "Gratis",
	commercial_discount: "Commerciële korting",
	log_in_or_register: "Log in of registreer om te boeken",
	login_register: "Doorgaan",
	email_not_valid: "Je e-mailadres is onjuist",
	user_info_mandatory_field: "Verplicht veld",
	user_info_invalid_phone: "Invalid format. Phone number must contain 10 numbers.",
	new_password_forgot_password: "Wachtwoord vergeten?",
	new_password_create_new_password: "Maak een nieuw wachtwoord aan",
	new_password1: "Nieuw wachtwoord",
	new_password2: "Bevestig je wachtwoord",
	user_info_forgot_password: "Wachtwoord vergeten?",
	user_info_already_have_account: "Heb je al een account?",
	user_info_enter_email: "Klik hier om jouw wachtwoord aan te passen",
	user_info_email_sent: "Een link om je wachtwoord te resetten is verzonden naar",
	user_info_new_password: "Voer je nieuwe wachtwoord in",
	send: "Stuur",
	validate: "Bevestig",
	i_want_to_register: "Account aanmaken",
	i_want_to_login: "Inloggen",
	new_password_succes: "Je wachtwoord is aangepast",
	user_info_your_informations: "Jouw gegevens",
	contacts_first_name: "Voornaam",
	contacts_last_name: "Achternaam",
	contacts_email: "E-mail",
	contacts_other_email: "Inloggen met een andere e-mail",
	contacts_password1: "Wachtwoord",
	contacts_password2: "Bevestig je wachtwoord",
	contacts_password_format: "Je wachtwoord moet",
	contacts_password_format_lenght: "Minstens 8 tekens bevatten",
	contacts_password_format_lowercase: "Minstens 1 kleine letter bevatten",
	contacts_password_format_uppercase: "Minstens 1 hoofdletter bevatten",
	contacts_password_format_number: "Minstens 1 cijfer bevatten",
	contacts_password_format_character: "minstens 1 speciaal teken bevatten (# ; @ ; \$ ...)",
	contacts_passwords_dont_match: "Het wachtwoord komt niet overeen",
	contacts_email_is_not_valid: "Het e-mailadres is niet geldig",
	user_info_to_contact_you: "Mijn contactgegevens",
	contacts_address: "Adres",
	contacts_city: "Stad",
	contacts_country: "Land",
	contacts_postal_code: "Postcode",
	contacts_phone_number: "00 00 00 00 00",
	contacts_subscribe_newsletter: "Ik wil me graag abonneren op de Travelski.nl nieuwsbrief en profiteren van aanbiedingen!",
	contacts_accept_conditions_1: "Ik accepteer de",
	contacts_accept_conditions_2: "ANVR-reizigersvoorwaarden",
	contacts_accept_conditions_3: "&",
	contacts_accept_conditions_4: "Aanvullende Travelski.nl voorwaarden",
	update_my_details: "Mijn gegevens bijwerken",
	continue_with_these_contacts: "Doorgaan met deze informatie",
	user_info_lihe_more_details: "Meer gegevens",
	user_info_create_account: "Maak een account aan",
	user_info_is_it_first_time: "Ga je voor het eerst op reis met Travelski?",
	error_wrong_email: "Het ingevoerde e-mailadres is ongeldig. Controleer de gegevens en probeer opnieuw.",
	payment_my_account: "Mijn account",
	payment_choose_method: "Kies betaalmethode",
	proceed_to_payment: "Ga naar de betaalomgeving",
	payment_by_credit_card: "Betaling met creditcard",
	flex_product: "Flex",
	payment_credit_card_payment_condition_1_desc_1: "Bij het Flex-tarief is de aanbetaling bij boeking",
	payment_credit_card_payment_condition_1_desc_2: ", wat overeenkomt met",
	payment_credit_card_payment_condition_1_desc_3: "van de totale reissom (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
	payment_credit_card_payment_condition_1_desc_4: "Het restbedrag",
	payment_credit_card_payment_condition_1_desc_5: ", wordt automatisch afgeschreven op",
	payment_credit_card_payment_condition_1_notice_1: "30% aanbetaling bij boeking, gratis wijzigen tot",
	payment_credit_card_payment_condition_1_notice_1_2: "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen)",
	payment_credit_card_payment_condition_1_notice_2_2: ". Aanpassing van opties uitgezonderd de accommodatie volgens",
	payment_credit_card_payment_condition_1_notice_2_3: "ANVR-reisvoorwaarden",
	payment_credit_card_payment_condition_1_notice_2_4: "&",
	payment_credit_card_payment_condition_1_notice_2_5: "Aanvullende Travelski.nl voorwaarden",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_1: "Bij het Flex-tarief is de aanbetaling bij boeking",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_2: ", wat overeenkomt met",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_3: "van de totale reissom (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_4: "Het restbedrag",
	payment_credit_card_payment_condition_1_desc_PV_before_deposit_5: ", wordt automatisch afgeschreven op",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_1: "30% aanbetaling bij boeking, gratis wijzigen tot",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_2: "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen). Wijzigingen van anders diensten, uitgezonderd de accommodatie, volgens",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_3: "ANVR-reisvoorwaarden",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_4: "&",
	payment_credit_card_payment_condition_1_notice_PV_before_deposit_5: "Aanvullende Travelski.nl voorwaarden",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_1: "Bij het Flex-tarief brengen wij bij boeking de totale reissom",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_2: "in rekening (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_3: "Kosteloos annuleren en wijzigen tot",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_4: "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen). Wijzigingen van anders diensten, uitgezonderd de accommodatie, en bij annulering Dutchweek, dan volgens",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_5: "ANVR-reisvoorwaarden",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_6: "&",
	payment_credit_card_payment_condition_1_desc_PV_after_deposit_7: "Aanvullende Travelski.nl voorwaarden",
	payment_credit_card_payment_condition_1_notice_PV_after_deposit_1: "Volledige betaling bij boeking.",
	fix_product: "Fix",
	payment_credit_card_payment_condition_2_desc_1: "Bij het FIX-tarief brengen wij bij boeking de totale reissom",
	payment_credit_card_payment_condition_2_desc_2: "in rekening (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen). Dit bedrag is niet-restitueerbaar.",
	payment_credit_card_payment_condition_2_desc_3: "Wijzigingen van anders diensten, uitgezonderd de accommodatie, en bij annulering Dutchweek, dan volgens",
	payment_credit_card_payment_condition_2_desc_4: "ANVR-reisvoorwaarden",
	payment_credit_card_payment_condition_2_desc_5: "&",
	payment_credit_card_payment_condition_2_desc_6: "Aanvullende Travelski.nl voorwaarden",
	payment_credit_card_payment_condition_2_notice_1: "Volledige betaling bij boeking. Niet-restitueerbaar.",
	card_number: "Kaartnummer",
	credit_card_date: "MM/JJ",
	cvc: "CVC",
	where_find_cvc: "Waar vind ik mijn CVC?",
	cvc_popup_title: "Waar vind ik mijn verificatiecode?",
	cvc_popup_desc: "Voor MasterCard en Visa kaarten vind je de 3-cijferige code op de achterkant van je kaart, in het handtekeninggedeelte.",
	invalid_format: "Ongeldig formaat",
	invalid_card_detail: "De ingevoerde creditcardgegevens zijn ongeldig. Controleer de informatie alstublieft.",
	pay_with_ideal: "Betaal met iDeal",
	pay_with_bancontact: "Betaal met Bancontact",
	choose_bank: "Selecteer je bank",
	payment_error_popup_title: "Betaling geweigerd",
	payment_error_popup_text: "Excuses, je betaling is geweigerd. Probeer het opnieuw of neem contact met ons op via",
	confirmation_error_popup_phone: "020 8200 600",
	confirmation_error_popup_phone_yoonly: "+32 2 808 25 70",
	payment_error_popup_button: "OK",
	devis_desc_4: "Let op:",
	devis_desc_5: "Controleer de beschikbaarheid van je verblijf op het moment van boeken",
	payment_status_check_payment: "Betaling controleren",
	payment_status_confirm_payment: "Betaling bevestigen",
	payment_status_check_availability: "Controleer de beschikbaarheid van de accommodatie",
	summary_accommodation_details: "Accommodatie informatie",
	summary_package_total: "Je pakket",
	summary_thanks_to_pack_you_save: "Met je Travelski pakket bespaar je:",
	summary_fee: "Boekingskosten",
	summary_fee_NL_SGRcontribution: "SGR bijdrage (€5 / pers.)",
	summary_fee_NL_Calamiteitenfonds: "Calamiteitenfonds (€2,50 / 9 pers.)",
	summary_fee_WIYP: "Boekingskosten",
	summary_fee_NL_SGRcontribution_WIYP: "SGR bijdrage inbegrepen (€5 / pers.)",
	summary_fee_NL_Calamiteitenfonds_WIYP: "Calamiteitenfonds inbegrepen (€2,50 / 9 pers.)",
	promocode: "Kortingscode?",
	promocode_wrong: "De kortingscode die je hebt ingevoerd is ongeldig",
	promocode_first_name: "Voornaam",
	promocode_last_name: "Achternaam",
	promocode_last_6_digits: "Laatste 6 cijfers van je kaart-/nummer",
	promocode_date_of_birth: "Geboortedatum (dd/mm/jjjj)",
	promocode_date_of_birth_day: "Dag",
	promocode_date_of_birth_month: "Maand",
	promocode_date_of_birth_year: "Jaar",
	promocode_mandatory_field: "Verplichte velden",
	promocode_invalid_format: "Onjuist formaat",
	green_banner: "Door te boeken bij Travelski profiteer je van de beste prijsgarantie",
	summary_enter_code: "Voer kortingscode in",
	summary_validate: "Bevestig",
	summary_total: "Totaal",
	summary_book: "Naar de volgende stap",
	confirmation_status_reservation_title: "Wat fijn je boeking is bevestigd!",
	confirmation_status_reservation_subtitle_1: "Je reis begint over",
	confirmation_status_reservation_subtitle_2: "dagen.",
	confirmation_reservation_1: "Over enkele minuten ontvang je je boekingsbevestiging",
	confirmation_reservation_2: "Je betaalt nu direct",
	confirmation_reservation_3: "wat overeenkomt met",
	confirmation_reservation_4: "% van de totale reissom.",
	confirmation_reservation_5: "De restbetaling van",
	confirmation_reservation_6: "dient voor",
	confirmation_reservation_7: "betaald te zijn.",
	confirmation_reservation_8: "Je vindt al deze informatie in je Travelski-account. Om in te loggen",
	confirmation_reservation_9: "klik hier",
	confirmation_reservation_10: ".",
	confirmation_by_phone: "Bel een specialist",
	confirmation_booking_100_percent_1: "Je ontvangt binnen enkele minuten de bevestiging van je reis en die van je betaling.",
	confirmation_booking_100_percent_2: "Ter herinnering, vandaag schrijven we",
	confirmation_booking_100_percent_3: "af, wat overeenkomt met 100% van het bedrag van je reis.",
	confirmation_booking_100_percent_4: "Je vindt al deze informatie op je Travelski-account. Je kunt",
	confirmation_booking_100_percent_5: "hier",
	confirmation_booking_100_percent_6: "inloggen.",
	confirmation_status_reservation_title_already_paid: "Je verblijf is al betaald",
	confirmation_reserve_quick: "Boek",
	confirmation_status_error_title: "Helaas, er is een fout opgetreden",
	confirmation_error_1: "Helaas kan je boeking niet worden bevestigd. Probeer het later nogmaals of neem contact met ons op via",
	confirmation_other_payment_method: "020 8200 600",
	confirmation_error_1_sentence: "Helaas kon je boeking niet verwerkt worden",
	confirmation_unavailable_text: "Het gewenste verblijf is helaas niet meer beschikbaar. Probeer het opnieuw of neem contact met ons op via",
	confirmation_error_text: "Helaas, je verblijf is niet meer beschikbaar. Probeer het opnieuw of neem contact met ons op via",
	confirmation_error_phone: "020 8200 600",
	confirmation_make_reservation_account_title: "Mijn account:",
	confirmation_make_reservation_account: "Log in op \"Mijn account\" om je boekinggegevens te vinden",
	confirmation_make_reservation_account_button: "Ga naar mijn account",
	confirmation_make_reservation_phone_title: "Telefonisch",
	confirmation_make_reservation_phone_1: "Bel een van onze experts",
	confirmation_make_reservation_phone_2: "020 8200 600",
	confirmation_status_unavailable_title: "Helaas, deze accommodatie is ofwel niet meer beschikbaar, of enkel te boeken in een pakket (met skipassen).",
	confirmation_status_unavailable_subtitle: "Excuses, de door jou geselecteerde accommodatie is niet langer beschikbaar.",
	confirmation_unavailable_1: "De door jou geselecteerde wintersport is niet langer beschikbaar omdat deze zojuist online door een ander is geboekt.",
	confirmation_unavailable_2: "Er zijn geen kosten in rekening gebracht.",
	confirmation_find_another: "Zoek een ander verblijf",
	confirmation_find_another_same_title: "Behoud dezelfde accommodatie",
	confirmation_find_another_same_1: "Is dit je favoriete accommodatie en ben je flexibel? Wijzig dan de data van je verblijf of kies een ander appartement / hotelkamer.",
	confirmation_find_another_same_button: "Keer terug naar de accommodatie-pagina",
	confirmation_find_another_other_title: "Verblijf in hetzelfde dorp en/of skigebied",
	confirmation_find_another_other_1: "Dit skigebied is erg populair, maar we weten zeker dat je een leuke reis zult vinden!",
	confirmation_find_another_other_button: "Onze andere accommodaties op",
	confirmation_find_another_search_title: "Zoek opnieuw",
	confirmation_find_another_search_1: "Wil je een andere accommodatie zoeken in dit dorp?",
	confirmation_find_another_search_2: "Geen probleem, Travelski biedt verblijven 100+ skidorpen!",
	confirmation_find_another_search_button: "Zoek opnieuw",
	confirmation_find_another_question_title: "Heb je een vraag of opmerking?",
	confirmation_find_another_question_1: "020 8200 600",
	confirmation_your_order: "De door jouw gemaakte boeking",
	confirmation_summary_details_button: "Boekingsgegevens",
	confirmation_access_account: "Ga naar mijn account",
	Transport_private: "Kies een privétransfer voor meer comfort en flexibiliteit",
	Transport_arrival: "Bij aankomst wacht een privé-chauffeur mij op bij het station om me naar mijn accommodatie te brengen.",
	Transport_return: "Bij terugkeer wacht een chauffeur me op bij de ingang van mijn accommodatie in het skigebied om me terug te brengen naar het treinstation.",
	smile_and_pass: "Smile&Pass: je skipas(sen) krijg je tegelijkertijd bij het ophalen van je accommodatiesleutels",
	Transport_coaches: "Speciale wagons met ruime stoelen en stopcontacten",
	Transport_meal: "Avondeten en ontbijt is inbegrepen op de heenreis; lunch en thee/koffie is inbegrepen op de terugreis.",
	Transfer_private: "Kies een privétransfer voor meer comfort en flexibiliteit",
	Transfer_bus: "Kies een bustransfer tussen het treinstation en het resort",
	snowboard_seul_argent_name: "Snowboard only zilver (snowboard)",
	snowboard_seul_argent_description: "Voor mijn eerste snowboardlessen en om plezier te hebben op de eenvoudige pistes",
	snowboard_seul_or_name: "Snowboard only goud (snowboard)",
	snowboard_seul_or_description: "Op de pistes en in het funpark board ik met gemak en ik kies prestatiegericht materiaal",
	pack_argent_snowboard_name: "Package Zilver (snowboard + schoenen)",
	pack_argent_snowboard_description: "Om te starten met snowboarden of vooruitgang te boeken, kies ik voor veelzijdig en speels materiaal",
	pack_or_snowboard_name: "Package Goud (snowboard + schoenen)",
	pack_or_snowboard_description: "Op de pistes en in het funpark board ik met gemak en ik kies prestatiegericht materiaal",
	skis_seuls_argent_name: "Ski’s only zilver (ski’s + skistokken)",
	skis_seuls_argent_description: "Voor mijn eerste skilessen en om plezier te hebben op de eenvoudige pistes, kies ik wendbaar materiaal",
	skis_seuls_or_name: "Ski’s only goud (ski’s + skistokken)",
	skis_seuls_or_description: "Met een comfortabel gevoel op de pistes zoek ik naar uitrusting om mezelf te verbeteren op alle delen van de berg",
	skis_seuls_platine_name: "Ski’s only platinum (ski’s + skistokken)",
	skis_seuls_platine_description: "Ik ben een goede skiër en kies voor technisch en prestatiegericht materiaal voor maximaal plezier",
	pack_eco_name: "Package Eco (ski’s + skischoenen)",
	pack_eco_description: "Ongeacht je niveau, je bent op zoek naar betaalbare uitrusting",
	pack_argent_name: "Package Zilver (ski’s + skischoenen)",
	pack_argent_description: "Je beheerst je bochten en remt gemakkelijk op blauw en rood",
	pack_or_name: "Package Goud (ski’s + skischoenen)",
	pack_or_description: "Ronde en gesneden bochten, controle snelheid op rood/zwart",
	pack_platine_name: "Package Platinum (ski’s + skischoenen)",
	pack_platine_description: "Je bent altijd in balans, kan skiën in alle sneeuwcondities en je kiest uitstekend materiaal",
	pack_mini_kid_ski_name: "Package Mini kid 2-5 jaar (ski’s + schoenen)",
	pack_mini_kid_ski_description: "Voor de allerjongsten en 1ste skiervaring hebben",
	pack_espoir_skis_name: "Pack Espoir 6-11 jaar (ski’s + schoenen)",
	pack_espoir_skis_description: "Makkelijk sturen en remmen, niveau tot 2e ster",
	pack_champion_skis_name: "Pack Champion 6-11 jaar (ski’s + schoenen)",
	pack_champion_skis_description: "Snellere en parallelbochten, v.a. 2e ster of hoger",
	pack_espoir_snowboard_name: "Pack Espoir 6-11 jaar (snowboard + schoenen)",
	pack_espoir_snowboard_description: "Makkelijk sturen en remmen",
	pack_champion_snowboard_name: "Pack Champion 6-11 jaar (snowboard + schoenen)",
	pack_champion_snowboard_description: "Hogere snelheden en snellere bochten",
	global_insurance_conditions: "Bekijk de voorwaarden van de verzekering",
	contacts_incorrect_credentials: "Jouw inloggegevens zijn onjuist",
	voir_le_detail_de_mon_trajet: "Bekijk de details van mijn reis",
	i_dont_want: "Ik hoef geen",
	login_page_title: "Klantaccount",
	accommodation_popup: "Accommodatie informatie",
	liheDesc_included: "Beschikbare diensten",
	planner_what_is_included: "Wat is inbegrepen?",
	productDesc_advantage: "Faciliteiten",
	planner_prestationsAppartmentEquipment: "Jouw gekozen accommodatie heeft:",
	planner_prestationsPrivateBathroom: "Badkamer/douchecabine:",
	planner_prestationsPrivateKitchen: "Keuken/kitchenette:",
	planner_prestationsPrivateServices: "Beschikbare diensten",
	prestation_floorNumber: "Verdieping",
	criteria_354: "16 kamers",
	criteria_353: "15 kamers",
	criteria_352: "14 kamers",
	criteria_351: "13 kamers",
	criteria_350: "12 kamers",
	criteria_349: "11 kamers",
	criteria_348: "10 kamers",
	criteria_347: "9 kamers",
	criteria_346: "8 kamers",
	criteria_345: "7 kamers",
	criteria_344: "6 kamers",
	criteria_343: "5 kamers",
	criteria_342: "4 kamers",
	criteria_341: "3 kamers",
	criteria_340: "2 kamers",
	criteria_339: "1 kamer",
	criteria_338: "20 slaapkamers",
	criteria_337: "19 slaapkamers",
	criteria_336: "18 slaapkamers",
	criteria_335: "17 slaapkamers",
	criteria_334: "16 slaapkamers",
	criteria_333: "15 slaapkamers",
	criteria_332: "14 slaapkamers",
	criteria_331: "13 slaapkamers",
	criteria_330: "12 slaapkamers",
	criteria_329: "11 slaapkamers",
	criteria_328: "10 slaapkamers",
	criteria_327: "9 slaapkamers",
	criteria_326: "8 slaapkamers",
	criteria_325: "7 slaapkamers",
	criteria_324: "6 slaapkamers",
	criteria_323: "5 slaapkamers",
	criteria_322: "4 slaapkamers",
	criteria_321: "3 slaapkamers",
	criteria_320: "2 slaapkamers",
	criteria_319: "1 slaapkamer",
	criteria_985: "5x tweepersoonsbed",
	criteria_982: "4x tweepersoonsbed",
	criteria_983: "3x tweepersoonsbed",
	criteria_762: "2x tweepersoonsbed",
	criteria_741: "1x tweepersoonsbed",
	criteria_987: "10x éénpersoonsbed",
	criteria_986: "9x éénpersoonsbed",
	criteria_988: "8x éénpersoonsbed",
	criteria_984: "7x éénpersoonsbed",
	criteria_767: "6x éénpersoonsbed",
	criteria_766: "5x éénpersoonsbed",
	criteria_765: "4x éénpersoonsbed",
	criteria_764: "3x éénpersoonsbed",
	criteria_763: "2x éénpersoonsbed",
	criteria_742: "1x éénpersoonsbed",
	criteria_769: "4x stapelbed",
	criteria_768: "2x stapelbed",
	criteria_743: "1x stapelbed",
	criteria_747: "1x tweepersoons slaapbank",
	criteria_771: "2x slaapbank",
	criteria_745: "1x slaapbank",
	criteria_744: "1x onderschuifbed",
	criteria_46: "Babybed (op aanvraag)",
	criteria_746: "Bank",
	criteria_29: "Balkon/Terras",
	criteria_773: "Balkons",
	criteria_739: "Balkon",
	criteria_738: "Terras",
	criteria_761: "Tussenverdieping",
	criteria_30: "Begane grond",
	criteria_55: "Wifi beschikbaar",
	criteria_27: "TV",
	criteria_23: "Wasmachine",
	criteria_803: "Wasdroger",
	criteria_47: "Babykit (op aanvraag)",
	criteria_799: "Schoonmaakset",
	criteria_48: "Barbecue",
	criteria_25: "Airco",
	criteria_981: "Aparte toiletten",
	criteria_31: "Persoon met beperkte mobiliteit",
	criteria_705: "Complete keuken",
	criteria_757: "Aparte keuken",
	criteria_22: "Vaatwasser",
	criteria_756: "Koelkast",
	criteria_759: "Kookplaat",
	criteria_750: "Oven",
	criteria_758: "Magnetron",
	criteria_752: "Koffiezetapparaat",
	criteria_754: "Fluitketel",
	criteria_755: "Broodrooster",
	criteria_715: "Douche",
	criteria_714: "Bad",
	criteria_748: "Beddengoed",
	criteria_45: "Badlinnen",
	criteria_801: "Opgemaakte bedden bij aankomst",
	criteria_51: "Eindschoonmaak",
	criteria_76: "Privézwembad",
	criteria_75: "Overdekt zwembad",
	criteria_74: "Buitenzwembad",
	criteria_74_76: "Privé buitenzwembad",
	criteria_75_76: "Overdekt privézwembad",
	criteria_71: "Spa",
	criteria_733: "Fitnessruimte",
	criteria_69: "Hammam",
	criteria_70: "Sauna",
	criteria_732: "Jacuzzi",
	criteria_36: "Overdekte parking",
	criteria_37: "Overdekte parking",
	criteria_798: "Lift",
	criteria_979: "Kinderclub",
	criteria_815: "100% - 18-35 JAAR",
	criteria_52: "Huisdieren toegestaan",
	criteria_800: "Ski locker",
	criteria_980: "Bagageruimte",
	criteria_312: "Dichtbij winkels",
	criteria_807: "Op 50 m van winkels",
	criteria_808: "Op 100 m van winkels",
	criteria_306: "Op 200 m van winkels",
	criteria_307: "Op 500 m van winkels",
	criteria_308: "Op 1 km van winkels",
	criteria_309: "Meer dan 1 km van winkels",
	criteria_310: "Meer dan 1 km van winkels",
	criteria_311: "Meer dan 1 km van winkels",
	criteria_365: "Nabij skischool",
	criteria_720: "Op 50 m van de skischool",
	criteria_721: "Op 100 m van de skischool",
	criteria_359: "Op 200 m van de skischool",
	criteria_360: "Op 500 m van de skischool",
	criteria_361: "Op 1 km van de skischool",
	criteria_362: "Meer dan 1 km van de skischool",
	criteria_363: "Meer dan 1 km van de skischool",
	criteria_364: "Meer dan 1 km van de skischool",
	criteria_305: "In centrum",
	criteria_718: "Op 50 m van het centrum",
	criteria_719: "Op 100 m van het centrum",
	criteria_299: "Op 200 m van het centrum",
	criteria_300: "Op 500 m van het centrum",
	criteria_301: "Op 1 km van het centrum",
	criteria_302: "Meer dan 1 km van het centrum",
	criteria_303: "Meer dan 1 km van het centrum",
	criteria_304: "Meer dan 1 km van het centrum",
	criteria_291: "Aan de piste",
	criteria_716: "Op 50 m van de pistes",
	criteria_717: "Op 100 m van de pistes",
	criteria_285: "Op 200 m van de pistes",
	criteria_822: "Op 300 m van de pistes",
	criteria_286: "Op 500 m van de pistes",
	criteria_287: "Op 1 km van de pistes",
	criteria_288: "Meer dan 1 km van de pistes",
	criteria_289: "Meer dan 1 km van de pistes",
	criteria_290: "Meer dan 1 km van de pistes",
	criteria_60: "Cateringservice",
	criteria_61: "Cateringservice",
	criteria_62: "Cateringservice",
	criteria_63: "Cateringservice",
	criteria_64: "Cateringservice",
	criteria_65: "Cateringservice",
	criteria_67: "Cateringservice",
	criteria_66: "Cateringservice",
	criteria_700: "Bij het inchecken ontvang je naast je sleutels ook direct je geboekte skipassen",
	session_expired: "Je sessie is verlopen, vernieuw alsjeblieft je pagina.",
	reload_page: "Vernieuw"
}
